import React from 'react';

type Props = {
  tags: string[];
};

const TagPills: React.FC<Props> = ({ tags }) => {
  return (
    <div className="flex flex-wrap gap-2  mx-4 mb-4">
      {tags?.map((tag, index) => (
        <span
          key={index}
          className="px-3 py-1 bg-primary/20 text-primary text-xs font-semibold rounded-full"
          style={{ textTransform: 'lowercase' }}
        >
          #{tag.toLowerCase()}
        </span>
      ))}
    </div>
  );
};

export default TagPills;
